import React from "react";
import { api } from "../../api/config";
import { RecordContextType } from "../../components/record/Record";
import { router } from "../../browser-router/router";
import { getStore } from "../../store/store";
import { SMSDialog } from "../../components/sms-dialog/SMSDialog";
import { openGenerateInstrumentLinksDialog } from "../treatments/actions-utils/GenerateInstrumentLinksDialog";
import { formatDate } from "../../utils/dateUtils";

export const actions = [
	{
		code: "convert_client",
		name: "Converter Para Cliente",
		actionFn: (context: any, executeAction: any) => convertToClient(context)
	},
	{
		code: "send_sms",
		name: "Enviar SMS",
		actionFn: (context: any, executeAction: any) => openSmsDialog(context)
	},
	{
		code: "generate_instrument_links",
		name: "Enviar Email com Instrumentos (novo)",
		actionFn: (context: RecordContextType) => openGenerateInstrumentLinksDialog(context)
	}
];

const convertToClient = async (context: RecordContextType) => {
	const email = context.item.email;
	const phone = context.item.phone;
	const name = `${context.item.first_name} ${context.item.last_name}`;
	const birthday = formatDate(context.item.birthday);
	const clinic = context.item.clinic?.name;

	const requiredFields = [
		{ label: "Nome", value: context.item.first_name },
		{ label: "Apelido", value: context.item.last_name },
		{ label: "Email", value: email },
		{ label: "Telemóvel", value: phone },
		{ label: "Data de nascimento", value: birthday },
		{ label: "Clínica", value: clinic }
	];
	const missingFields = requiredFields
		.filter((field) => !field.value || String(field.value).trim() === "")
		.map((field) => field.label);

	if (missingFields.length > 0) {
		const { notifications } = getStore();
		notifications.setNotification({
			isOpen: true,
			message: `Não é possível converter para cliente. Preencha os campos em falta: ${missingFields.join(", ")}.`,
			severity: "error"
		});
		return;
	}

	const confirmed = window.confirm(
		`Tem a certeza que a informação em baixo está correta?\n- Nome: ${name}\n- Data de nascimento: ${birthday}\n- Email: ${email}\n- Telemóvel: ${phone}\n- Clínica: ${clinic}.\n\nApós pressionar OK esses dados serão utilizados para criar o ID do cliente.`
	);
	if (!confirmed) return;

	try {
		const response = await api({
			method: "POST",
			url: "https://hook.eu1.make.com/nxhuuudduop4f8g34xjta0il2mob5nqj",
			data: context.item
		});

		const data = response.data;

		router.navigate(`/clients/${data.client_id}/update`);
	} catch (error: any) {
		throw new Error(error.response.data);
	}
};

const openSmsDialog = (context: RecordContextType) => {
	try {
		const { appDialog } = getStore();

		appDialog.createDialog({
			title: "Enviar SMS",
			contentAndActions: React.createElement(SMSDialog, {
				context: context,
				onClose: () => appDialog.toggleIsOpen()
			}),
			allowSoftCancel: true
		});

		return {
			showSuccessMessage: "no"
		};
	} catch (error: any) {
		throw new Error("algo correu mal");
	}
};
